import React from "react";
import classes from "./Banner3.module.scss";
import CustomImage from "../../CustomImage";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import Banner from "../Banner/Banner";
import useIsMobile from "../../../hooks/useIsMobile";

const Banner3 = ({ bannerData }: { bannerData: any }) => {
  const isMobile = useIsMobile(1024);
  return (
    <Banner bannerData={bannerData ?? {}} bgInverted={false} bannerStyles={isMobile ? {} : { width: "calc(100vw - 429px - 90px)" }}>
      <div className={classes["co-banner-container"]}>
        <div className={classes["co-banner-content"]}>
          <h2 className={classes["co-banner-title"]}>{bannerData?.title ?? ""}</h2>
          <p className={classes["co-banner-description"]}>{bannerData?.subtitle ?? ""}</p>
        </div>

        <div className={classes["co-banner-btn-container"]}>
          <button className={`${classes["co-banner-btn"]} ${isFrappeOrJotFormClass(bannerData?.enquireForm?.url)}`}>{bannerData?.btnLabel ?? ""}</button>

          <div className={classes["kc-overseas-icon"]}>
            <CustomImage src="/icons/kc_union.svg" height={128} width={222} alt={"kc-overseas-icon"} />
          </div>
        </div>
      </div>
    </Banner>
  );
};

export default Banner3;
